<template>
  <div class="mb-3 field-container" :class="{ error: !!field.error }">
    <label
      :for="field.id"
      class="form-label"
      :class="{ 'text-danger': !!field.error }"
      >{{ field.name + (field.required && '*') }}
      <Tooltip
        v-show="!!field.tooltipInfo"
        :id="field.id"
        :info="field.tooltipInfo"
      />
    </label>
    <input
      :type="field.type || 'text'"
      class="form-control no-border"
      :id="field.id"
      :value="field.value"
      :placeholder="field.placeholder"
      @input="onInputChange"
    />
  </div>
</template>
<script>
import Tooltip from '../global/Tooltip.vue';

export default {
  name: 'TextField',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  components: {
    Tooltip,
  },
  methods: {
    onInputChange($event) {
      this.$emit('input', $event.target.value);
    },
  },
  computed: {
    labelId() {
      return this.label
        .toLowerCase()
        .split(' ')
        .join('_');
    },
  },
};
</script>

<style lang="scss" scoped>
input:focus {
  border: none;
  outline: none !important;
}
.no-border {
  border: 0;
  box-shadow: none; /* You may want to include this as bootstrap applies these styles too */
}
.form-control {
  border: none;
  padding: 0px;
  font-size: 18px;
  line-height: 22px;
  outline: none !important;
  color: #000;
}

.form-label {
  font-size: 13px;
  line-height: 19px;
}

.field-container {
  border: 0.5px solid #b1b1b1;
  border-radius: 3px;
  padding: 8px 12px;
}
.error {
  border-color: $danger;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  color: #000;
}
</style>
